//import logo from './logo.svg';
import Header from './components/Header';
//import Footer from './components/Footer';
import Home from './views/Home';
import About from './views/About';
import Preorder from './views/Preorder';
import {Routes, Route} from 'react-router-dom';
import './App.css';

function App() {
  return (
    <>
      <div className="App">
        <Header />
      </div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/preorder" element={<Preorder />} />
      </Routes>
    </>
    
  );
}

export default App;
